<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <content-area :items="shortUneditableItems" />

        <template v-for="(value, key) in longUneditableItems">
          <strong :key="value">
            {{ key }}
          </strong>
          <v-textarea
            class="monospace"
            auto-grow
            rows="1"
            readonly
            :value="longUneditableItems[key]"
            :key="key"
          />
        </template>

        <strong>
          CKA_SUBJECT
        </strong>
        <v-textarea
          auto-grow
          rows="1"
          row-height="5"
          v-model="CKA_SUBJECT_value"
          counter
          :error-messages="CKA_SUBJECT_valueErrors"
          @input="$v.CKA_SUBJECT_value.$touch()"
          @blur="$v.CKA_SUBJECT_value.$touch()"
        />
        <v-switch color="green" label="CKA_DERIVE" v-model="CKA_DERIVE_value" :ripple="false" />
        <v-switch color="green" label="CKA_WRAP" v-model="CKA_WRAP_value" :ripple="false" />
        <v-switch color="green" label="CKA_UNWRAP" v-model="CKA_UNWRAP_value" :ripple="false" />
        <v-switch color="green" label="CKA_SIGN" v-model="CKA_SIGN_value" :ripple="false" />
        <v-switch color="green" label="CKA_VERIFY" v-model="CKA_VERIFY_value" :ripple="false" />
        <v-switch color="green" label="CKA_ENCRYPT" v-model="CKA_ENCRYPT_value" :ripple="false" />
        <v-switch color="green" label="CKA_DECRYPT" v-model="CKA_DECRYPT_value" :ripple="false" />
        <v-switch color="green" label="CKA_SIGN_RECOVER" v-model="CKA_SIGN_RECOVER_value" :ripple="false" />
        <v-switch color="green" label="CKA_VERIFY_RECOVER" v-model="CKA_VERIFY_RECOVER_value" :ripple="false" />
        <v-switch color="green" label="CKA_TRUSTED" v-model="CKA_TRUSTED_value" :ripple="false" />
        <v-switch color="green" label="CKA_WRAP_WITH_TRUSTED" v-model="CKA_WRAP_WITH_TRUSTED_value" :ripple="false" />

        <!-- CKA_OBJECT_ID -->
        <v-text-field
          label="CKA_OBJECT_ID"
          v-model="CKA_OBJECT_ID_value"
          counter
          :error-messages="CKA_OBJECT_ID_valueErrors"
          @input="$v.CKA_OBJECT_ID_value.$touch()"
          @blur="$v.CKA_OBJECT_ID_value.$touch()"
        />

        <!-- CKA_ID -->
        <v-text-field
          label="CKA_ID"
          v-model="CKA_ID_value"
          counter
          :error-messages="CKA_ID_valueErrors"
          @input="$v.CKA_ID_value.$touch()"
          @blur="$v.CKA_ID_value.$touch()"
        />

        <!-- CKA_LABEL -->
        <v-text-field
          label="CKA_LABEL"
          v-model="CKA_LABEL_value"
          counter
          :error-messages="CKA_LABEL_valueErrors"
          @input="$v.CKA_LABEL_value.$touch()"
          @blur="$v.CKA_LABEL_value.$touch()"
        />

        <!-- CKA_APPLICATION -->
        <v-text-field
          label="CKA_APPLICATION"
          v-model="CKA_APPLICATION_value"
          counter
          :error-messages="CKA_APPLICATION_valueErrors"
          @input="$v.CKA_APPLICATION_value.$touch()"
          @blur="$v.CKA_APPLICATION_value.$touch()"
        />

        <!-- CKA_JMIDP_SEC_DOMAIN -->
        <v-text-field
          label="CKA_JMIDP_SEC_DOMAIN"
          v-model="CKA_JMIDP_SEC_DOMAIN_value"
          counter
          :error-messages="CKA_JMIDP_SEC_DOMAIN_valueErrors"
          @input="$v.CKA_JMIDP_SEC_DOMAIN_value.$touch()"
          @blur="$v.CKA_JMIDP_SEC_DOMAIN_value.$touch()"
        />

        <!-- CKA_CERT_CATEGORY -->
        <v-text-field
          label="CKA_CERT_CATEGORY"
          v-model="CKA_CERT_CATEGORY_value"
          counter
          :error-messages="CKA_CERT_CATEGORY_valueErrors"
          @input="$v.CKA_CERT_CATEGORY_value.$touch()"
          @blur="$v.CKA_CERT_CATEGORY_value.$touch()"
        />

        <!-- CKA_KEY_GEN_MECHANISM -->
        <v-text-field
          label="CKA_KEY_GEN_MECHANISM"
          v-model="CKA_KEY_GEN_MECHANISM_value"
          counter
          :error-messages="CKA_KEY_GEN_MECHANISM_valueErrors"
          @input="$v.CKA_KEY_GEN_MECHANISM_value.$touch()"
          @blur="$v.CKA_KEY_GEN_MECHANISM_value.$touch()"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ContentArea from '@/components/ContentArea.vue'
import { maxLength } from 'vuelidate/lib/validators'

export default {
  components: {
    ContentArea
  },
  props: {
    name: {
      type: String,
      required: false,
      default: ''
    },
    ponze: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  methods: {
    onCopy: function (e) {
      // alert('You just copied: ' + e.text)
    },
    onError: function (e) {
      alert('Failed to copy texts')
    },
    intOrBoolean (key, val) {
      const booleanKeys = ['CKA_EXTRACTABLE', 'CKA_SENSITIVE', 'CKA_NEVER_EXTRACTABLE', 'CKA_LOCAL', 'CKA_TOKEN', 'CKA_MODIFIABLE', 'CKA_PRIVATE']
      if (booleanKeys.includes(key)) {
        return val === 1 ? this.$tc('yes') : this.$tc('no')
      }
      return val
    },
    getKeyTypeSize (type) {
      const algDetail = this.$store.getters['keys/getKeyType']({
        type
      })
      return algDetail.type + algDetail.size
    }
  },
  computed: {
    inputPolicy () {
      return this.$store.state.secPolicy
    },
    shortUneditableItems () {
      const uneditableKeys = ['CKA_KEY_TYPE', 'CKA_CLASS', 'CKA_EXTRACTABLE', 'CKA_SENSITIVE', 'CKA_NEVER_EXTRACTABLE', 'CKA_LOCAL', 'CKA_CERTIFICATE_TYPE', 'CKA_PUBLIC_EXPONENT', 'CKA_TOKEN', 'CKA_MODIFIABLE', 'CKA_MODULUS_BITS', 'CKA_PRIVATE']
      const myItems = []
      for (const key of uneditableKeys) {
        if (this.ponze && this.ponze[key]) {
          switch (key) {
            case 'CKA_KEY_TYPE':
              myItems.push(
                {
                  title: key,
                  data: this.ponze.CKA_KEY_TYPE
                  // data: this.getKeyTypeSize(this.ponze.CKA_KEY_TYPE)
                }
              )
              break
            // TODO: Do more cases
            default:
              // No mapping needed, just show int or bool
              myItems.push(
                {
                  title: key,
                  data: this.intOrBoolean(key, this.ponze[key])
                }
              )
          }
        }
      }
      return myItems
    },
    longUneditableItems () {
      const longUneditableKeys = ['CKA_MODULUS', 'CKA_EC_PARAMS', 'CKA_PUBLIC_KEY_INFO']
      const myItems = {}
      for (const key of longUneditableKeys) {
        if (this.ponze && this.ponze[key]) {
          myItems[key] = this.ponze[key]
        }
      }
      return myItems
    },
    CKA_OBJECT_ID_value: {
      get () {
        return this.$store.state.keys.CKA_OBJECT_ID
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_OBJECT_ID', val)
      }
    },
    CKA_CLASS_value: {
      get () {
        return this.$store.state.keys.CKA_CLASS
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_CLASS', val)
      }
    },
    CKA_LOCAL_value: {
      get () {
        return this.$store.state.keys.CKA_LOCAL
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_LOCAL', val)
      }
    },
    CKA_TOKEN_value: {
      get () {
        return this.$store.state.keys.CKA_TOKEN
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_TOKEN', val)
      }
    },
    CKA_PRIVATE_value: {
      get () {
        return this.$store.state.keys.CKA_PRIVATE
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_PRIVATE', val)
      }
    },
    CKA_MODIFIABLE_value: {
      get () {
        return this.$store.state.keys.CKA_MODIFIABLE
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_MODIFIABLE', val)
      }
    },
    CKA_EXTRACTABLE_value: {
      get () {
        return this.$store.state.keys.CKA_EXTRACTABLE
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_EXTRACTABLE', val)
      }
    },
    CKA_SENSITIVE_value: {
      get () {
        return this.$store.state.keys.CKA_SENSITIVE
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_SENSITIVE', val)
      }
    },
    CKA_NEVER_EXTRACTABLE_value: {
      get () {
        return this.$store.state.keys.CKA_NEVER_EXTRACTABLE
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_NEVER_EXTRACTABLE', val)
      }
    },
    CKA_TRUSTED_value: {
      get () {
        return this.$store.state.keys.CKA_TRUSTED
      },
      set (val) {
        const trustedIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_TRUSTED', trustedIntBool)
      }
    },
    CKA_WRAP_WITH_TRUSTED_value: {
      get () {
        return this.$store.state.keys.CKA_WRAP_WITH_TRUSTED
      },
      set (val) {
        const wrapWithTrustedIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_WRAP_WITH_TRUSTED', wrapWithTrustedIntBool)
      }
    },
    CKA_SUBJECT_value: {
      get () {
        return this.$store.state.keys.CKA_SUBJECT
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_SUBJECT', val)
      }
    },
    CKA_LABEL_value: {
      get () {
        return this.$store.state.keys.CKA_LABEL
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_LABEL', val)
      }
    },
    CKA_ID_value: {
      get () {
        return this.$store.state.keys.CKA_ID
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_ID', val)
      }
    },
    CKA_APPLICATION_value: {
      get () {
        return this.$store.state.keys.CKA_APPLICATION
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_APPLICATION', val)
      }
    },
    CKA_JMIDP_SEC_DOMAIN_value: {
      get () {
        return this.$store.state.keys.CKA_JMIDP_SEC_DOMAIN
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_JMIDP_SEC_DOMAIN', val)
      }
    },
    CKA_CERT_CATEGORY_value: {
      get () {
        return this.$store.state.keys.CKA_CERT_CATEGORY
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_CERT_CATEGORY', val)
      }
    },
    CKA_KEY_GEN_MECHANISM_value: {
      get () {
        return this.$store.state.keys.CKA_KEY_GEN_MECHANISM
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_KEY_GEN_MECHANISM', val)
      }
    },
    CKA_KEY_TYPE_value: {
      get () {
        return this.$store.state.keys.username
      },
      set (val) {
        this.$store.commit('keys/SET_CKA_KEY_TYPE', val)
      }
    },
    CKA_DERIVE_value: {
      get () {
        return this.$store.state.keys.CKA_DERIVE
      },
      set (val) {
        const deriveIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_DERIVE', deriveIntBool)
      }
    },
    CKA_WRAP_value: {
      get () {
        return this.$store.state.keys.CKA_WRAP
      },
      set (val) {
        const wrapIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_WRAP', wrapIntBool)
      }
    },
    CKA_UNWRAP_value: {
      get () {
        return this.$store.state.keys.CKA_UNWRAP
      },
      set (val) {
        const unwrapIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_UNWRAP', unwrapIntBool)
      }
    },
    CKA_SIGN_value: {
      get () {
        return this.$store.state.keys.CKA_SIGN
      },
      set (val) {
        const signIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_SIGN', signIntBool)
      }
    },
    CKA_VERIFY_value: {
      get () {
        return this.$store.state.keys.CKA_VERIFY
      },
      set (val) {
        const verifyIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_VERIFY', verifyIntBool)
      }
    },
    CKA_ENCRYPT_value: {
      get () {
        return this.$store.state.keys.CKA_ENCRYPT
      },
      set (val) {
        const encryptIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_ENCRYPT', encryptIntBool)
      }
    },
    CKA_DECRYPT_value: {
      get () {
        return this.$store.state.keys.CKA_DECRYPT
      },
      set (val) {
        const decryptIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_DECRYPT', decryptIntBool)
      }
    },
    CKA_SIGN_RECOVER_value: {
      get () {
        return this.$store.state.keys.CKA_SIGN_RECOVER
      },
      set (val) {
        const signRecoverIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_SIGN_RECOVER', signRecoverIntBool)
      }
    },
    CKA_VERIFY_RECOVER_value: {
      get () {
        return this.$store.state.keys.CKA_VERIFY_RECOVER
      },
      set (val) {
        const verifyRecoverIntBool = val ? 1 : 0
        this.$store.commit('keys/SET_CKA_VERIFY_RECOVER', verifyRecoverIntBool)
      }
    },
    // ERRORS //
    // INT
    CKA_JMIDP_SEC_DOMAIN_valueErrors () {
      const errors = []
      if (!this.$v.CKA_JMIDP_SEC_DOMAIN_value.$dirty) return errors
      !this.$v.CKA_JMIDP_SEC_DOMAIN_value.validINTcharacter &&
        errors.push(this.$t('$validation.int_not_valid'))
      return errors
    },
    CKA_CERT_CATEGORY_valueErrors () {
      const errors = []
      if (!this.$v.CKA_CERT_CATEGORY_value.$dirty) return errors
      !this.$v.CKA_CERT_CATEGORY_value.validINTcharacter &&
        errors.push(
          this.$t('$validation.int_not_valid', {
            num: this.inputPolicy.max_hex
          })
        )
      return errors
    },
    CKA_KEY_GEN_MECHANISM_valueErrors () {
      const errors = []
      if (!this.$v.CKA_KEY_GEN_MECHANISM_value.$dirty) return errors
      !this.$v.CKA_KEY_GEN_MECHANISM_value.validINTcharacter &&
        errors.push(
          this.$t('$validation.int_not_valid', {
            num: this.inputPolicy.max_hex
          })
        )
      return errors
    },
    // HEX
    CKA_OBJECT_ID_valueErrors () {
      const errors = []
      if (!this.$v.CKA_OBJECT_ID_value.$dirty) return errors
      !this.$v.CKA_OBJECT_ID_value.validHEXcharacter &&
        errors.push(this.$t('$validation.hex_not_valid'))
      return errors
    },
    CKA_ID_valueErrors () {
      const errors = []
      if (!this.$v.CKA_ID_value.$dirty) return errors
      !this.$v.CKA_ID_value.validHEXcharacter &&
        errors.push(this.$t('$validation.hex_not_valid'))
      return errors
    },
    CKA_SUBJECT_valueErrors () {
      const errors = []
      if (!this.$v.CKA_SUBJECT_value.$dirty) return errors
      !this.$v.CKA_SUBJECT_value.validHEXcharacter &&
        errors.push(this.$t('$validation.hex_not_valid'))
      return errors
    },
    // STRING
    CKA_LABEL_valueErrors () {
      const errors = []
      if (!this.$v.CKA_LABEL_value.$dirty) return errors
      !this.$v.CKA_LABEL_value.maxLength &&
        errors.push(
          this.$t('$validation.max_length', {
            num: this.$v.CKA_LABEL_value.$params.maxLength.max
          })
        )
      return errors
    },
    CKA_APPLICATION_valueErrors () {
      const errors = []
      if (!this.$v.CKA_APPLICATION_value.$dirty) return errors
      !this.$v.CKA_APPLICATION_value.maxLength &&
        errors.push(
          this.$t('$validation.max_length', {
            num: this.$v.CKA_APPLICATION_value.$params.maxLength.max
          })
        )
      return errors
    }
  },
  validations () {
    const validINTcharacter = value => {
      if (!value) return true
      const numbeOfValidChars = (value.match(/[0-9]/g) || []).length
      return !(value.length - numbeOfValidChars > 0)
    }

    const validHEXcharacter = value => {
      if (!value) return true
      const numbeOfValidChars = (value.match(/[0-9A-Fa-f]/g) || []).length
      return !(value.length - numbeOfValidChars > 0)
    }

    return {
      CKA_JMIDP_SEC_DOMAIN_value: {
        validINTcharacter
      },
      CKA_CERT_CATEGORY_value: {
        validINTcharacter
      },
      CKA_KEY_GEN_MECHANISM_value: {
        validINTcharacter
      },
      CKA_LABEL_value: {
        maxLength: maxLength(this.inputPolicy.max_length_string)
      },
      CKA_APPLICATION_value: {
        maxLength: maxLength(this.inputPolicy.max_length_string)
      },
      CKA_OBJECT_ID_value: {
        validHEXcharacter
      },
      CKA_ID_value: {
        validHEXcharacter
      },
      CKA_SUBJECT_value: {
        validHEXcharacter
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-grey {
  color: #424242;
}

.list {
  padding: 2;
}

.list-group {
  &::before,
  &::after {
    background: none !important;
  }
}
.table {
  border: solid 1px #cbcbcb;
  border-collapse: collapse;
  border-spacing: 0;
  font: normal 13px Arial, sans-serif;
}
.table tr {
  border: solid 1px #cbcbcb;
  color: #336b6b;
  padding: 10px;
  text-align: left;
  text-shadow: 1px 1px 1px #fff;
}
.table td {
  border: solid 1px #cbcbcb;
  color: #333;
  padding: 10px;
  text-shadow: 1px 1px 1px #fff;
}

.v-card {
  background-color: transparent;
}
</style>
